import React from 'react';
import { Dialog } from 'primereact/dialog';
import './ModalMensagem.css';

const ModalMensagem = ({ visible, onHide, tipo = 'aviso', mensagem, imagem }) => {
    return (
        <Dialog 
            visible={visible} 
            onHide={onHide} 
            closable 
            className={`modal-mensagem modal-${tipo}`} 
            header={null}
            footer={null}
            modal
        >
            <div className="modal-conteudo">
                {imagem && <img src={imagem} alt="Ilustra��o" className="modal-imagem" />}
                <p className="modal-texto">{mensagem}</p>
            </div>
        </Dialog>
    );
};

export default ModalMensagem;